<div class="container">
  <h2 class="my-5">Frequently Asked Questions</h2>

  <dl>
    <dt>Are the power outlets 120 volts or 210 volts?</dt>
    <dd>Power outlets are 120 volts (the same as in the United States). </dd>
    <dt>Are there any day or time restrictions for drinking alcohol?</dt>
    <dd>Alcohol is not allowed to be served or sold between the hours of midnight and 9:00 a.m. </dd>
    <dt>What is the legal drinking age in Taniti?</dt>
    <dd>The drinking age on Taniti is 18 and the drinking age is not strictly enforced.</dd>
    <dt>Is English spoken in Taniti?</dt>
    <dd>Many younger Tanitians speak fluent English. Very little English is spoken in rural areas, especially by the older residents.</dd>
    <dt>If I get injured, are there hospitals nearby?</dt>
    <dd>There is one hospital and several clinics. The hospital has many multilingual employees.</dd>
    <dt>Am I safe walking alone?</dt>
    <dd>Violent crime is very rare on Taniti, but as tourism increases, there are more reports of pickpocketing and other petty crimes.</dd>
    <dt>Are there special days where businesses close on the island?</dt>
    <dd>Taniti enjoys a large number of national holidays, and many tourist attractions and restaurants will be closed on holidays, so visitors should plan accordingly.</dd>
    <dt>What currency is accepted?</dt>
    <dd>Taniti uses the U.S. dollar as its currency, but many businesses will also accept euros and yen. Several banks facilitate currency exchange, and many businesses accept major credit cards.</dd>

  </dl>
</div>
